import AdminClient from '@/api/AdminClient';
import moment from 'moment';

export default class SessionsReport {
  constructor() {
    this.adminClient = null;
    this.schoolId = 0;
    this.loading = false;

    this.token = undefined;

    this.parameters = {
      pageToken: undefined,
      from: undefined,
      through: undefined,
      customCampusTags: undefined
    };

    this.sessions = [];
  }

  get error() {
    return this.token && this.token.error;
  }

  get hasNext() {
    return !!this.parameters.pageToken;
  }

  initialize($http, schoolId) {
    this.adminClient = new AdminClient($http);
    this.schoolId = schoolId;

    return this;
  }

  asCanceledStatuses() {
    this.parameters.pageToken = null;
    this.parameters.includeStatuses = [
      'AdminCanceled',
      'UserCanceled',
      'UserLateCanceled',
      'CounselorCanceled',
    ];
    return this;
  }

  asNotAttendedStatuses() {
    this.parameters.pageToken = null;
    this.parameters.includeStatuses = [
      'UserNoShow',
      'CounselorNoShow',
      'BothNoShow'
    ];
    return this;
  }

  asSuccessStatuses() {
    this.parameters.pageToken = null;
    this.parameters.includeStatuses = [
      'Upcoming',
      'InProgress',
      'Successful',
    ];
    return this;
  }

  asAllStatuses() {
    this.parameters.pageToken = null;
    this.parameters.includeStatuses = undefined;
    return this;
  }

  from(d) {
    this.parameters.pageToken = null;
    this.parameters.from = d ? moment(d) : null;

    return this;
  }
  through(d) {
    this.parameters.pageToken = null;
    this.parameters.through = d ? moment(d) : null;

    return this;
  }

  asAllPast() {
    this.parameters.from = null;
    this.parameters.through = moment();
    return this;
  }

  asLast30Days() {
    this.parameters.from = moment().add(-30, 'day');
    this.parameters.through = moment();
    return this;
  }

  asUpcoming() {
    this.parameters.from = moment();
    this.parameters.through = null;
    return this;
  }

  fetch() {
    if(!this.parameters.pageToken)
      this.sessions.length = 0;
    return this.#callAsyncAndIgnorePreviousCalls(
      this.#getData.bind(this), 
      this.#handleResponse.bind(this));
  }

  async #callAsyncAndIgnorePreviousCalls(call, onsuccess) {
    if (this.token) {
      this.token.canceled = true;
    }

    const localToken = {
      error: undefined,
      canceled: false
    };
    this.token = localToken;

    try {
      const result = await call()

      if (localToken.canceled) {
        return;
      }

      onsuccess(result);

    } catch (error) {
      localToken.error = error;
      throw error;
    }
  }

  #getData() {
    try {
      this.loading = true;

      return this.adminClient.getCollegeAdminSessionsListReport(
        this.schoolId,
        this.parameters.from,
        this.parameters.through,
        this.parameters.includeStatuses,
        this.parameters.pageToken,
        this.parameters.customCampusTags
      );
    } catch (error) {
      this.loading = false;
      throw error;
    }
  }

  #handleResponse(response){
    this.parameters.pageToken = response.nextPageToken;
    this.sessions.push(...response.sessions)
    this.loading = false;
  }
  withCustomTags(tagsList) {
    this.parameters.customCampusTags = tagsList;
    return this;
  }
}
